// import {client} from "@gradio/client";
import { toast } from "react-toastify";
import { SDAutomatic, SDXL } from "../../constants/sd-models";
import { authHeaders, del, get, post, put } from "../../utils/fetch";
import { Hosts, PredictionStatus, RequestState } from "../../constants";
import _ from "lodash";
import { getUrlFromPath } from "./Showcases/ShowcaseSketchApi";
import { getOndemandErrorMsg } from "../../utils";

let eventSource = null;
let vitonWc = null;
let abortPolling = false;

export const FETCH_API_KEYS = 'FETCH_API_KEYS';
export const ROTATE_API_KEY = 'ROTATE_API_KEY';
export const CREATE_API_KEY = 'CREATE_API_KEY';
export const DELETE_API_KEY = 'DELETE_API_KEY';
export const UPDATE_API_KEY = 'UPDATE_API_KEY';
export const INFER_REQUEST = 'INFER_REQUEST';
export const PRE_SIGN_URL = 'PRE_SIGN_URL';
export const PREDICTION_STARTED = "PREDICTION_STARTED";
export const PREDICTION_IN_PROGRESS = "PREDICTION_IN_PROGRESS";
export const PREDICTION_STOPPED = "PREDICTION_STOPPED";


export const selectApiKeys = (state) => state.models.apiKeys;
export const selectPredictionStatus = (state) => state.models.predictionStatus;
export const selectPredictionId = (state) => state.models.predictionId;

export const AiOndemandApi = {
  actions: {
    fetchModelApiKeys: (project_id) => async (dispatch, getState) => {
      let result = await get({
        host: Hosts.ONDEMAND_MODEL_API,
        url: `/api_key/${project_id}/list`,
        headers: authHeaders(),
        action: FETCH_API_KEYS,
        dispatch,
      });
      return _.get(result, 'body.api_keys');
    },
    rotateModelApiKey: (id) => async (dispatch, getState) => {
      let result = await put({
        host: Hosts.ONDEMAND_MODEL_API,
        url: `/api_key/${id}/renew`,
        headers: authHeaders(),
        action: ROTATE_API_KEY,
        dispatch,
      });
      return _.get(result, 'body');
    },
    createModelApiKey: (projectId) => async (dispatch, getState) => {
      let result = await post({
        host: Hosts.ONDEMAND_MODEL_API,
        url: `/api_key`,
        headers: authHeaders(),
        action: CREATE_API_KEY,
        body: { project_id: projectId },
        dispatch,
      });
      return _.get(result, 'body');
    },
    deleteModelApiKey: (id) => async (dispatch, getState) => {
      let result = await del({
        host: Hosts.ONDEMAND_MODEL_API,
        url: `/api_key/${id}`,
        headers: authHeaders(),
        action: DELETE_API_KEY,
        dispatch,
      });
      return _.get(result, 'body');
    },
    updateModelApiKeyName: (id, name) => async (dispatch, getState) => {
      let result = await put({
        host: Hosts.ONDEMAND_MODEL_API,
        url: `/api_key/${id}`,
        headers: authHeaders(),
        action: UPDATE_API_KEY,
        body: {
          name: name
        },
        dispatch,
      });
      return _.get(result, 'body');
    },

    startHostedPredict: (params, modelName, key, prediction) => async (dispatch, getState) => {
      dispatch({ type: PREDICTION_STARTED });
      let input = {};
      let url = '';
      switch (modelName) {
        case 'SD':
          input = {
            "prompt": params.prompt,
            "steps": params.steps,
            "seed": params.seed,
            "cfg_scale": params.guidanceScale,
            "sampler_index": "Euler a",
            "width": params.width,
            "height": params.height
          }
          url = '/infer_request/stable_diffusion_turbo_vision';
          break;
        case 'SDXL':
          url = '/infer_request/stable_diffusion_xl_turbo';
          input = {
            "prompt": params.prompt,
            "steps": params.steps,
            "seed": params.seed,
            "strength": params.strength,
            "guidanceScale": params.guidanceScale
          };
          break;
        case 'llama3-8b':
          url = "/infer_request/llama_3_8b/completions";
          input = params;
          break;
        case 'img-to-img':
          input = params;
          url = `/infer_request/image_to_image${prediction && `/${prediction}`}`
          break;
        case 'SDV':
          input = params;
          url = `/infer_request/stable_diffusion_video`;
          break;
        case 'flux':
          input = {
            "prompt": params.prompt,
            "num_steps": params.steps,
            "seed": params.seed + '',
            "guidance": params.guidanceScale,
            "width": params.width,
            "height": params.height,
            "image2image_strength": params.strength
          }
          url = `/infer_request/flux`;
          break;
        case 'whisper':
          input = params;
          url = `/infer_request/whisper`;
          break;
        case 'talking-head':
          if (prediction === 'generate_video') {
            input = {
              "img": params.img,
              "audio": params.audio
            }
          }
          if (prediction === 'generate_audio') {
            input = {
              "prompt": params.prompt,
              "description": params.description
            }
          }
          url = `/infer_request/talking_head/${prediction}`;
          break;
        case 'esrgan':
          input = params;
          url = `/infer_request/esrgan`;
          break;
        case 'blip':
          input = params;
          url = `/infer_request/blip`;
          break;
        case 'grounding-dino':
          input = params;
          url = `/infer_request/grounding_dino`;
          break;
        case 'kokoro-82m':
          input = {
            "text": params.text,
            "voice": params.voice,
            "speed": params.speed,
          }
          url = '/infer_request/kokoro_82m';
          break;
        case 'SV':
          input = {
            steps: params.steps,
            model_img: params.model,
            garment_img: params.garment,
            clothing_type: params.clothingType
          }
          url = '/infer_request/stable_viton/2';
          break;
        case 'step-video':
          input = params;
          url = '/infer_request/step_video';
          break;
        case 'instant-id':
          input = params;
          url = `/infer_request/instant_id`;
          break;
        case 'voice-cloning':
          input = params;
          url = `/infer_request/voice_cloning`;
          break;
        default:
          break;
      };

      let result = await post({
        host: Hosts.ONDEMAND_MODEL_API,
        url,
        headers: {
          Authorization: `Bearer ${key}`
        },
        action: INFER_REQUEST,
        body: { input },
        dispatch,
      });
      const predictionId = _.get(result, 'body.infer_requests.0.id');
      if (!predictionId) {
        throw new Error("Failed to create prediction: No prediction ID returned.");
      }

      abortPolling = false;
      dispatch({ type: PREDICTION_IN_PROGRESS, payload: { predictionId } })
      return await pollPredictionStatus(dispatch, predictionId, key);
    },
    stopHostedPredict: (predictionId, key) => async (dispatch, getState) => {
      try {
        abortPolling = true;
        const result = await post({
          host: Hosts.ONDEMAND_MODEL_API,
          url: `/infer_request/${predictionId}/cancel`,
          headers: {
            Authorization: `Bearer ${key}`
          },
          dispatch,
        });
        return result;
      } catch (error) {
        console.error("Error stopping prediction:", error);
        throw error;
      }
    },

    hostedCreateCompletion: (params, key, onEvent = () => { }, mName, curUser) => async (dispatch, getState) => {
      const input = {
        messages: [
          { "role": "system", "content": "You are a helpful assistant." },
          ...params.messages
        ],
        stream: params.stream,
        max_tokens: params.max_tokens,
        temperature: params.temperature,
        top_p: params.top_p
      };

      let model = mName.replaceAll('-', '_');

      try {
        const response = await fetch(`${Hosts.ONDEMAND_MODEL_API}/infer_request/${model}/completions`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${key}`
          },
          body: JSON.stringify({ input }),
        });

        if (!response.ok) {
          const errorMessage = await response.json();
          console.log('errorMessage:', errorMessage)
          throw new Error(errorMessage.message);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let done = false;
        let fullMessage = '';

        while (!done) {
          const { value, done: readerDone } = await reader.read();
          done = readerDone;

          const chunk = decoder.decode(value, { stream: true });
          const lines = chunk.split('\n').filter(line => line.trim() !== '');

          for (const line of lines) {
            if (line.startsWith('data: ')) {
              const data = line.substring(6);

              // End of stream signal
              if (data === '[DONE]') {
                done = true;
                onEvent({ type: 'done', content: fullMessage })
                break;
              }

              try {
                const parsedData = JSON.parse(data);
                const content = _.get(parsedData, 'choices.0.delta.content');
                if (content) {
                  fullMessage += content;
                  onEvent({ type: 'chunk', content })
                }
              } catch (err) {
                console.error('Error parsing stream data:', err);
              }
            }
          }
        }

        return fullMessage;
      } catch (e) {
        onEvent({ type: 'error', error: getOndemandErrorMsg(e.message, curUser) })
      }
    },
    presignUrl: (alias, prediction, key) => async (dispatch, getState) => {
      let result = await post({
        host: Hosts.ONDEMAND_MODEL_API,
        url: `/infer_request/${alias}${prediction ? `/${prediction}` : ''}/input_presigned_urls`,
        headers: {
          Authorization: `Bearer ${key}`
        },
        action: PRE_SIGN_URL,
        dispatch,
      });
      return _.get(result, 'body');
    },
    uploadImageToBucket: (file, url, name) => async (dispatch, getState) => {
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': file.type,
          'Content-Type': 'application/octet-stream'
        },
        body: file,
      });
    },

    generateImprovedImagePrompt: (prompt) => async (dispatch, getState) => {
      const chatbotModel = _.find(getState().models.showcases, showcase => showcase.name === 'Chatbot').models[0];
      return await dispatch(AIShowcase.actions.createCompletion(chatbotModel, {
        messages: [
          {
            "role": "system",
            "content": "You are an expert prompt engineer. Your task is to transform user inputs into highly detailed and vivid text prompts suitable for generating images using the Stable Diffusion model. Respond with the improved prompt only. Do not include any additional text, explanations, or prefixes."
          },
          { "role": "user", "content": prompt }
        ],
        "max_tokens": 200,
        "temperature": 0.4,
        "stream": true
      }))
    },


    stopImageToVideoGeneration: () => async (dispatch, getState) => {
      if (eventSource) {
        eventSource.close()
        eventSource = null
      }
    },

    fetchExploreTextToImage: () => async (dispatch, getState) => {
      const response = await fetch("https://sheet2api.com/v1/RSBMaYwSHCof/thetaedgecloud-ai-showcase-endpoints")
      const json = await response.json()
      return json;
    },

    stopVitonGeneration: () => async (dispatch, getState) => {
      if (vitonWc) {
        vitonWc.close()
        vitonWc = null
      }
    },


    stopArtStyleTransferGeneration: () => async (dispatch, getState) => {
      if (eventSource) {
        eventSource.close()
        eventSource = null
      }
    },


    stopGeneration: () => async (dispatch, getState) => {
      if (eventSource) {
        eventSource.close()
        eventSource = null
      }
    },

    reportStats: (params) => async (dispatch, getState) => {
      const response = await post({
        host: Hosts.EDGE_CLOUD_API,
        url: `/utilization_stats`,
        body: {
          table: 'showcase_analytics',
          ...params
        },
      })
    }

  },
  spec: {
    apiKeys: [],
    predictionStatus: PredictionStatus.STOPPED,
    predictionId: null
  },
  modelReducer: (state, type, body, action) => {
    if (action.url && action.result !== RequestState.SUCCESS)
      return state;
    if (type === FETCH_API_KEYS) {
      return {
        ...state,
        apiKeys: _.get(body, 'api_keys')
      }
    }
    if (type === PREDICTION_STARTED && state.predictionStatus !== PredictionStatus.STARTED) {
      return {
        ...state,
        predictionStatus: PredictionStatus.STARTED,
        predictionId: null
      }
    }
    if (type === PREDICTION_IN_PROGRESS && state.predictionStatus !== PredictionStatus.IN_PROGRESS) {
      return {
        ...state,
        predictionStatus: PredictionStatus.IN_PROGRESS,
        predictionId: _.get(action, 'payload.predictionId')
      }
    }
    if (type === PREDICTION_STOPPED && state.predictionStatus !== PredictionStatus.STOPPED) {
      return {
        ...state,
        predictionStatus: PredictionStatus.STOPPED,
        predictionId: null
      }
    }

    return state;
  }
}

const pollPredictionStatus = async (dispatch, predictionId, key) => {
  try {
    if (abortPolling) {
      console.log("Polling aborted.");
      dispatch({ type: PREDICTION_STOPPED })
      return;
    }
    const statusResult = await get({
      host: Hosts.ONDEMAND_MODEL_API,
      url: `/infer_request/${predictionId}`,
      headers: {
        Authorization: `Bearer ${key}`
      },
      dispatch,
    });

    let state = _.get(statusResult, 'body.infer_requests.0.state');

    if (state === "success" || state === "error" || state === "cancelled") {
      dispatch({ type: PREDICTION_STOPPED });
      return statusResult;
    }

    // Wait and poll again
    await new Promise(resolve => setTimeout(resolve, 500));
    return await pollPredictionStatus(dispatch, predictionId, key);
  } catch (error) {
    console.error("Error polling prediction status:", error);
    throw error;
  }
}
